import axiosInstance from "./axiosInstance";

export interface DepartmentApi {
  id: number;
  publicId: string;
  departmentCode: string;
  departmentName: string;
  status: boolean;
  description: string;
  headOfDepartment: string;
  employeeCount: number;
}

export interface DepartmentListResponse {
  items: DepartmentApi[];
  pageNo: number;
  pageSize: number;
  totalCount: number;
}

export interface CreateDepartmentPayload {
  departmentCode: string;
  departmentName: string;
  status: boolean;
  description: string;
  headOfDepartment: string;
  createdBy: string;
}

export interface UpdateDepartmentPayload {
  publicId: string;
  departmentCode: string;
  departmentName: string;
  status: boolean;
  description: string;
  headOfDepartment: string;
  updatedBy: string;
}

export interface EmployeeMasterApi {
  id: number;
  employeeNo: string;
  itsNo: string;
  fullName: string;
}

export const getAuthHeader = () => {
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getDepartments = async (params: {
  searchText?: string | null;
  pageNo: number;
  pageSize: number;
}): Promise<DepartmentListResponse> => {
  const res = await axiosInstance.get("/department-master/list", {
    headers: getAuthHeader(),
    params,
  });

  return res.data;
};

export const createDepartment = async (payload: CreateDepartmentPayload) => {
  const res = await axiosInstance.post("/department-master", payload, {
    headers: getAuthHeader(),
  });
  return res.data;
};

export const updateDepartment = async (payload: UpdateDepartmentPayload) => {
  const res = await axiosInstance.put("/department-master", payload, {
    headers: getAuthHeader(),
  });
  return res.data;
};

export const deleteDepartment = async (
  publicId: string,
  deletedBy: string
) => {
  const res = await axiosInstance.delete(
    `/department-master/${publicId}?deletedBy=${deletedBy}`,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};

export const getEmployees = async (): Promise<
  EmployeeMasterApi[]
> => {
  const res = await axiosInstance.get(
    "/EmployeeMaster",
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};